import React from 'react';
import { Card } from './SubscriptionAppCard/Card';
import { Badge } from './SubscriptionAppBadge/Badge';
import { Info } from 'lucide-react';
export function SellingPlansPanel() {
  return <div className="flex flex-col gap-6 max-w-5xl mx-auto" data-id="element-2532">
      {/* Selling Plan Groups Card */}
      <Card padding="none" className="border border-[#E2E8F0] overflow-hidden" data-id="element-2533">
        <div className="p-6 border-b border-[#E2E8F0]" data-id="element-2534">
          <div className="flex items-center justify-between mb-2" data-id="element-2535">
            <h2 className="text-[16px] font-semibold text-[#0F172A]" data-id="element-2536">
              Selling Plan Groups
            </h2>
            <Badge variant="success" data-id="element-2537">All synced</Badge>
          </div>
          <p className="text-[14px] text-[#64748B]" data-id="element-2538">
            Each pack size creates one Shopify Selling Plan Group. These are
            auto-generated from your Pack Sizes and Frequencies configuration.
          </p>
        </div>

        <div className="divide-y divide-[#E2E8F0]" data-id="element-2539">
          {/* 3-Pack Row */}
          <div className="p-6 flex items-center justify-between" data-id="element-2540">
            <div className="flex items-start gap-4" data-id="element-2541">
              <div className="w-10 h-10 rounded-lg bg-[#E0F2FE] text-[#0EA5E9] flex items-center justify-center font-semibold text-[16px]" data-id="element-2542">
                3
              </div>
              <div data-id="element-2543">
                <h3 className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2544">
                  3-Pack Taster Box
                </h3>
                <div className="flex items-center gap-2 mt-1 text-[13px] text-[#64748B]" data-id="element-2545">
                  <code className="bg-[#F1F5F9] px-1.5 py-0.5 rounded text-[#475569] font-mono text-[12px]" data-id="element-2546">
                    3pack-taster-box
                  </code>
                  <span data-id="element-2547">· 3 selling plans · Last synced 2 min ago</span>
                </div>
              </div>
            </div>
            <div className="text-right" data-id="element-2548">
              <div className="text-[16px] font-semibold text-[#0F172A]" data-id="element-2549">18</div>
              <div className="text-[11px] font-medium text-[#94A3B8] uppercase tracking-wider mb-1" data-id="element-2550">
                PRODUCTS
              </div>
              <Badge variant="success" data-id="element-2551">Synced</Badge>
            </div>
          </div>

          {/* 6-Pack Row */}
          <div className="p-6 flex items-center justify-between" data-id="element-2552">
            <div className="flex items-start gap-4" data-id="element-2553">
              <div className="w-10 h-10 rounded-lg bg-[#E0F2FE] text-[#0EA5E9] flex items-center justify-center font-semibold text-[16px]" data-id="element-2554">
                6
              </div>
              <div data-id="element-2555">
                <h3 className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2556">
                  6-Pack Mixed Case
                </h3>
                <div className="flex items-center gap-2 mt-1 text-[13px] text-[#64748B]" data-id="element-2557">
                  <code className="bg-[#F1F5F9] px-1.5 py-0.5 rounded text-[#475569] font-mono text-[12px]" data-id="element-2558">
                    6pack-mixed-case
                  </code>
                  <span data-id="element-2559">· 3 selling plans · Last synced 2 min ago</span>
                </div>
              </div>
            </div>
            <div className="text-right" data-id="element-2560">
              <div className="text-[16px] font-semibold text-[#0F172A]" data-id="element-2561">24</div>
              <div className="text-[11px] font-medium text-[#94A3B8] uppercase tracking-wider mb-1" data-id="element-2562">
                PRODUCTS
              </div>
              <Badge variant="success" data-id="element-2563">Synced</Badge>
            </div>
          </div>

          {/* 12-Pack Row */}
          <div className="p-6 flex items-center justify-between" data-id="element-2564">
            <div className="flex items-start gap-4" data-id="element-2565">
              <div className="w-10 h-10 rounded-lg bg-[#E0F2FE] text-[#0EA5E9] flex items-center justify-center font-semibold text-[16px]" data-id="element-2566">
                12
              </div>
              <div data-id="element-2567">
                <h3 className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2568">
                  12-Pack Cellar Selection
                </h3>
                <div className="flex items-center gap-2 mt-1 text-[13px] text-[#64748B]" data-id="element-2569">
                  <code className="bg-[#F1F5F9] px-1.5 py-0.5 rounded text-[#475569] font-mono text-[12px]" data-id="element-2570">
                    12pack-cellar-selection
                  </code>
                  <span data-id="element-2571">· 3 selling plans · Last synced 2 min ago</span>
                </div>
              </div>
            </div>
            <div className="text-right" data-id="element-2572">
              <div className="text-[16px] font-semibold text-[#0F172A]" data-id="element-2573">24</div>
              <div className="text-[11px] font-medium text-[#94A3B8] uppercase tracking-wider mb-1" data-id="element-2574">
                PRODUCTS
              </div>
              <Badge variant="success" data-id="element-2575">Synced</Badge>
            </div>
          </div>
        </div>

        <div className="bg-[#F0F9FF] p-4 flex gap-3 border-t border-[#E2E8F0]" data-id="element-2576">
          <Info className="w-5 h-5 text-[#0EA5E9] flex-shrink-0 mt-0.5" data-id="element-2577" />
          <p className="text-[13px] text-[#475569] leading-relaxed" data-id="element-2578">
            Selling plan groups are created and synced automatically when you
            save. Products in each pack size's collection are associated with
            their group. Don't edit these directly in Shopify — changes will be
            overwritten on next sync.
          </p>
        </div>
      </Card>

      {/* Discount Matrix Card */}
      <Card padding="none" className="border border-[#E2E8F0] overflow-hidden" data-id="element-2579">
        <div className="p-6 border-b border-[#E2E8F0]" data-id="element-2580">
          <h2 className="text-[16px] font-semibold text-[#0F172A] mb-2" data-id="element-2581">
            Discount Matrix
          </h2>
          <p className="text-[14px] text-[#64748B]" data-id="element-2582">
            The full grid of selling plans generated from your pack sizes ×
            frequencies. Each cell is one Shopify selling plan.
          </p>
        </div>

        <div className="overflow-x-auto" data-id="element-2583">
          <table className="w-full text-left border-collapse" data-id="element-2584">
            <thead data-id="element-2585">
              <tr className="bg-[#F8FAFC] border-b border-[#E2E8F0]" data-id="element-2586">
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] w-1/4" data-id="element-2587">
                  Pack Size
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] text-center w-1/5" data-id="element-2588">
                  Monthly
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] text-center w-1/5" data-id="element-2589">
                  Quarterly
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] text-center w-1/5" data-id="element-2590">
                  Biannual
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-[15%]" data-id="element-2591">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]" data-id="element-2592">
              {/* Row 1 */}
              <tr data-id="element-2593">
                <td className="px-6 py-4 border-r border-[#E2E8F0]" data-id="element-2594">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-2595">
                    3-Pack Taster
                  </div>
                  <div className="text-[13px] text-[#94A3B8]" data-id="element-2596">
                    Explorer tier
                  </div>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2597">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2598">
                    5% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2599">
                    sp_3p_monthly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2600">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2601">
                    10% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2602">
                    sp_3p_quarterly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2603">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2604">
                    15% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2605">
                    sp_3p_biannual
                  </code>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2606">
                  <Badge variant="success" data-id="element-2607">Synced</Badge>
                </td>
              </tr>

              {/* Row 2 */}
              <tr data-id="element-2608">
                <td className="px-6 py-4 border-r border-[#E2E8F0]" data-id="element-2609">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-2610">
                    6-Pack Mixed
                  </div>
                  <div className="text-[13px] text-[#94A3B8]" data-id="element-2611">
                    Enthusiast tier
                  </div>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2612">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2613">
                    10% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2614">
                    sp_6p_monthly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2615">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2616">
                    15% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2617">
                    sp_6p_quarterly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2618">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2619">
                    18% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2620">
                    sp_6p_biannual
                  </code>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2621">
                  <Badge variant="success" data-id="element-2622">Synced</Badge>
                </td>
              </tr>

              {/* Row 3 */}
              <tr data-id="element-2623">
                <td className="px-6 py-4 border-r border-[#E2E8F0]" data-id="element-2624">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-2625">
                    12-Pack Cellar
                  </div>
                  <div className="text-[13px] text-[#94A3B8]" data-id="element-2626">
                    Collector tier
                  </div>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2627">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2628">
                    15% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2629">
                    sp_12p_monthly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2630">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2631">
                    18% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2632">
                    sp_12p_quarterly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-2633">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-2634">
                    20% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-2635">
                    sp_12p_biannual
                  </code>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2636">
                  <Badge variant="success" data-id="element-2637">Synced</Badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>

      {/* Product Associations Card */}
      <Card padding="none" className="border border-[#E2E8F0] overflow-hidden" data-id="element-2638">
        <div className="p-6 border-b border-[#E2E8F0]" data-id="element-2639">
          <h2 className="text-[16px] font-semibold text-[#0F172A] mb-2" data-id="element-2640">
            Product Associations
          </h2>
          <p className="text-[14px] text-[#64748B]" data-id="element-2641">
            Which Shopify collections are linked to each selling plan group, and
            how many products have the plans attached.
          </p>
        </div>

        <div className="overflow-x-auto" data-id="element-2642">
          <table className="w-full text-left border-collapse" data-id="element-2643">
            <thead data-id="element-2644">
              <tr className="bg-[#F8FAFC] border-b border-[#E2E8F0]" data-id="element-2645">
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider w-1/3" data-id="element-2646">
                  Collection
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-1/4" data-id="element-2647">
                  Selling Plan Group
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-1/4" data-id="element-2648">
                  Products
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-[15%]" data-id="element-2649">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]" data-id="element-2650">
              <tr data-id="element-2651">
                <td className="px-6 py-4" data-id="element-2652">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-2653">
                    Club Reds — Taster Range
                  </div>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2654">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-[#F0F9FF] text-[#0284C7] border border-[#E0F2FE]" data-id="element-2655">
                    3-Pack Taster Box
                  </span>
                </td>
                <td className="px-6 py-4 text-center text-[14px] text-[#64748B]" data-id="element-2656">
                  18 of 18 linked
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2657">
                  <Badge variant="success" data-id="element-2658">Synced</Badge>
                </td>
              </tr>
              <tr data-id="element-2659">
                <td className="px-6 py-4" data-id="element-2660">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-2661">
                    Club Mixed — Full Range
                  </div>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2662">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-[#F0F9FF] text-[#0284C7] border border-[#E0F2FE]" data-id="element-2663">
                    6-Pack Mixed Case
                  </span>
                </td>
                <td className="px-6 py-4 text-center text-[14px] text-[#64748B]" data-id="element-2664">
                  24 of 24 linked
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2665">
                  <Badge variant="success" data-id="element-2666">Synced</Badge>
                </td>
              </tr>
              <tr data-id="element-2667">
                <td className="px-6 py-4" data-id="element-2668">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-2669">
                    Club Premium — Cellar Range
                  </div>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2670">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-[#F0F9FF] text-[#0284C7] border border-[#E0F2FE]" data-id="element-2671">
                    12-Pack Cellar Selection
                  </span>
                </td>
                <td className="px-6 py-4 text-center text-[14px] text-[#64748B]" data-id="element-2672">
                  22 of 24 linked
                </td>
                <td className="px-6 py-4 text-center" data-id="element-2673">
                  <Badge variant="warning" data-id="element-2674">2 pending</Badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bg-[#F0F9FF] p-4 flex gap-3 border-t border-[#E2E8F0]" data-id="element-2675">
          <Info className="w-5 h-5 text-[#0EA5E9] flex-shrink-0 mt-0.5" data-id="element-2676" />
          <p className="text-[13px] text-[#475569] leading-relaxed" data-id="element-2677">
            When products are added to or removed from a collection, we
            automatically add or remove the selling plan association on next
            sync. 2 products in "Club Premium" were recently added and will be
            linked on the next sync cycle.
          </p>
        </div>
      </Card>
    </div>;
}